<template>
  <div :class="classes"><slot /><span class="icon" test-id="info_card-icon">!</span></div>
</template>

<script>
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LsInfoCard',
  mixins: [themedComponentMixin],
  props: {
    danger: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return [
        'info-card',
        ...this.themedClass,
        {
          warning: this.danger,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.info-card {
  display: flex;
  align-items: center;
  background-color: $primary-light;
  padding: 20px 20px 20px 25px;
  position: relative;
  .icon {
    color: $white;
    background-color: $primary;
    border: 5px solid $primary-light;
    font-size: 2rem;
    font-weight: 700;
    padding-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    left: -20px;
    top: calc(50% - 20px);
  }
  &.themed-component {
    background-color: $theme-color-primary-light;
    .icon {
      color: $theme-color-white;
      background-color: $theme-color-primary;
      border: 5px solid $theme-color-primary-light;
    }
  }
}
.info-card.warning {
  background-color: $theme-color-danger-light;
  .icon {
    background-color: $theme-color-danger;
    border: 5px solid $theme-color-danger-light;
  }
}
@media (max-width: $mobile-max-width) {
  .info-card {
    margin-top: 20px;
    padding: 25px 20px 20px 20px;
    .icon {
      //to compensate for the 20px padding of parent
      margin-left: -20px;
      left: 50%;
      top: -20px;
    }
  }
}
</style>
